import * as Yup from 'yup';

export const CreateDripScheduleFormValidationSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required(`Please enter a name for the drip schedule.`),
        app_source_type: Yup.string().required(`Please select an application.`)
    });
};
